
import {Component, Vue} from "vue-property-decorator";
import MtsYetkiliKurumSecimi from "@/components/eicrapro/uyap/MtsYetkiliKurumSecimi.vue";
//@ts-ignore
import html2pdf from "html2pdf.js/dist/html2pdf";
import JSZip from "jszip";
import * as FileSaver from "file-saver";
import IldekiAdliyeler from "@/plugins/uyap-plugin/uyap/IldekiAdliyeler";
import IldekiIdariBirimler from "@/plugins/uyap-plugin/uyap/IldekiIdariBirimler";
import {AvukatIcraDosyalariTalep} from "@/plugins/uyap-plugin/uyap/AvukatIcraDosyalari";
import {UyapTakipTevziAlTaskHandler} from "@/plugins/uyap-plugin/store/modules/TaskHandler/UyapTakipTevziAlTaskHandler";


@Component({
  components: {MtsYetkiliKurumSecimi}
})
export default class Servisler extends Vue {

  response: any = null;
  mtsKurumId: any = null;

  async update() {
    await this.$store.dispatch('getTasksFromServer');
  }

  async pdfdeneme() {
    // TODO: responserda htmller array olarak birleştirilecek (htmls: Array<string>)

    let html = `<div id="servis_sonuc_8"><div id="content"><style>@media print {.hidden-print {display: none !important;} body{font-family: Arial, Helvetica, sans-serif;;}</style><div id="content_pdf"><table  class='table table-bordered table-striped'><tr><td style=" border: none; text-align: center; font-weight: 600; width: 100%;">BORÇLUYA AİT EGM Sorgu BİLGİLERİ</td></tr></table><fieldset style="margin-bottom: 10px;"><legend>Sorgulamaya Ait Genel Bilgiler</legend><table  class='table table-bordered table-striped'><tr><td style=" border: none; text-align: left; font-weight: 600;width: 250px;">İşlemi Gerçekleştirenin Adı Soyadı: </td><td style="border: none; text-align: left;">Av.  NİHAN ERDOĞAN</td></tr><tr><td style=" border: none; text-align: left; font-weight: 600;width: 250px;">Birim Adı/Dosya No: </td><td style="border: none; text-align: left;">Ankara 29. İcra Dairesi 2011/16313</td></tr><tr><td style=" border: none; text-align: left; font-weight: 600;width: 250px;">Borçlunun Adı Soyadı:</td><td style="border: none; text-align: left;"> KE*** ÖZ*****</td></tr><tr><td style=" border: none; text-align: left; font-weight: 600;width: 250px;">Borçlunun TC Kimlik No: </td><td style="border: none; text-align: left;">3********20</td></tr><tr><td style=" border: none; text-align: left; font-weight: 600;width: 250px;">Borçlunun Baba/Anne Adı: </td><td style="border: none; text-align: left;"> M******* /  F***</td></tr><tr><td style=" border: none; text-align: left; font-weight: 600;width: 250px;">Borçlunun Doğum Yılı: </td><td style="border: none; text-align: left;">1966</td></tr></table></fieldset><div><p style='border:1px solid #ddd;padding:10px;'><strong> Kişiye ait araç  kaydı var.</strong></p><div class="table-scrollable"><table class="table table-bordered table-striped"><tbody><tr style='font-weight:700;'><td>#</td><td>Plaka</td><td>Marka</td><td>Model</td><td>Tipi</td><td>Renk</td><td>Cins</td><td class="hidden-print">Mahrumiyet</td><td class="hidden-print haciz-talebi-ekle-btn"></td></tr><tr><td>1</td><td>34****39</td><td>OPEL</td><td>1997</td><td>ASTRA 1.6 İ</td><td>YEŞİL</td><td>OTOMOBİL</td><td class="hidden-print" style="width:6%;"><input type="button" id="mahrumiyetSorgulaBTN" value="Sorgula" onclick="DosyaBilgileriGoruntuleme.aracMahrumiyetBilgileri('34TB3939')"/></td><td class="hidden-print haciz-talebi-ekle-btn" style="width:10%;"><input type="button" value="Haciz Talebine Ekle" onclick="HacizTalebiGonderme.talepEkleEGMModal('34TB3939', '34****39');"/></td></tr></tbody></table></div><table style="border: none;margin-top:30px;"><tr><td style="width: 50%; border: none;"></td><td style="width: 50%; border: none;"><table style="border: none;"><tr><td style=" border: none; text-align: center; width: 100%;">19/12/2020 00:10</td></tr><tr><td style=" border: none; text-align: center; font-weight: 600; width: 100%;">Düzenleyen</td></tr><tr><td style=" border: none; text-align: center; font-weight: 600; width: 100%;">AVUKAT PORTAL BİLGİ SİSTEMİ</td></tr><tr><td style=" border: none; text-align: center; width: 100%;">Avukatların, Avukat Portal'dan almış oldukları hizmete ilişkin belgedir. </td></tr></table></td></tr></table></div></div></div><div style="width: 100%; border: none; text-align: center;padding: 30px;font-size: 18px;"><a id="15343430140504307215154437215530710341142727_print"class="print_btn" style="margin-right: 10px; color: blue;" href="javascript: void(0);">Yazdır</a><a id="15343430140504307215154437215530710341142727_pdf" class="pdf_btn" style="margin-right: 10px; color: blue;" href="javascript: void(0);">PDF</a></div>`;
    let div = document.createElement('div');
    div.innerHTML = html;

    let zip = new JSZip();

    let options = {
      margin: 1,
      image: {type: 'jpeg', quality: 0.98},
      html2canvas: {scale: 2},
      jsPDF: {unit: 'in', format: 'letter', orientation: 'portrait'}
    };

    await html2pdf().set(options).from(div).toPdf().get('pdf').outputPdf('blob').then((file:any) => {
      zip.file("takbis/asd.pdf", file);
    })
    zip.generateAsync({type: "blob"})
        .then(function (contents) {
          FileSaver.saveAs(contents, 'Dilekçeler');
        });
  }

  imzala() {
    let udfbase64 = `UEsDBBQACAgIAMkQZ1UAAAAAAAAAAAAAAAALAAAAY29udGVudC54bWyFk8uO2jAUhvd5CtdrCIRplVkkGdEyVKOqINGwGCGEXHKSuPUlsg1zeaF5g67Y5cXmJFyGGRZd5eTIx///f7ajm0cpyBaM5VrFNPD7lIBa64yrIqbzdNy9puQmIZ4XOZCVYA5Iro1kbsWzZn1ISeJFa60cKJdEnxbfRsN0uBiBAgkdUta7v/VO2nr3nNU743vecplEvdP6yugKjONgsWYFjNu9iYSMs1/8GSZMAspQIiB3P5kpOLoM+/51+IUSw4vyoul09bH1Wzun5cduxVB5ajj6YG6fnpISWAZmPM1zCy6mg34DJNfaXTR7GOPMvReBwMTKWWLAaoFIY1puRTeDnG2EazFVzLDCsKpMjsSIdcy44879JqcqXIkiwUHibeR/04Pgbfxi2ot6R4NYW/ckGuTtl6gW8sloBnZteLVn8h3qFzCCIwUmuXiK6YgzoQtKLB4PCg0avgLvQs6EBUq4Y4KvT7/j6SRdDdN0dvd1nt6uftzex/QP27JH3z7gHfPxSuX+GOPM72bIbWPWsDgo7YU6rbtD3fqNcYarTqsfDJbN+RgojN4odNENrj4PgjC8agGc53t3GMcwKZdgyQQeyExLps5TvcdQ/9tmsId6gIdEj08i8V4BUEsHCACC7aXYAQAASAMAAFBLAQIUABQACAgIAMkQZ1UAgu2l2AEAAEgDAAALAAAAAAAAAAAAAAAAAAAAAABjb250ZW50LnhtbFBLBQYAAAAAAQABADkAAAARAgAAAAA=`
    let blob = this.$helper.base64toBlob(udfbase64, 'xml');
    console.log(blob);
    this.$imza.dokumanImzala(blob);
  }

  bildirim() {
    this.$toast.warning('Bu bir bildirim örneğidir...')
  }

  download() {
    this.$helper.download('1690364477_blob.pdf', '/api/v1/file/download/1690364477_blob')
  }

  downloadExcel(){
    this.$helper.download('sonuc.xlsx', '/api/v1/export-to-excel/1')
  }

  async execBagkur() {
    this.response = await this.$uyap.DosyaBorcluBagkur().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123});
  }

  async execBorcluTakbis() {
    this.response = await this.$uyap.BorcluTakbisSorgulama().run({
      dosyaId: 123312,
      kisiKurumId: 123123
    });
  }

  async execAvukatIcraDosyalari() {
    let req=new AvukatIcraDosyalariTalep();
    req.dosyaYil=2023;
    this.response = await this.$uyap.AvukatIcraDosyalari().run(req);
  }

  async execBorcluPostaCeki() {
    this.response = await this.$uyap.BorcluPostaCeki().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123});
  }

  async execBorcluSgkHaciz() {
    this.response = await this.$uyap.BorcluSgkHaciz().run({dosyaId: 123, kisiKurumId: 123});
  }

  async execBorcluIski() {
    //this.response = await this.$uyap.BorcluIski().parse("");
    this.response = await this.$uyap.BorcluIski().run({dosyaId: 66154994, kisiKurumId: 30660481, sorguBakiye: 1});
  }

  async execBorcluDib() {
    this.response = await this.$uyap.BorcluDib().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123});
  }

  async execBorcluGib() {
    this.response = await this.$uyap.BorcluGib().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123});
  }

  async execBorcluGsm() {
    this.response = await this.$uyap.BorcluGsm().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123});
  }

  async execBorcluIcraDosyasi() {
    this.response = await this.$uyap.BorcluIcraDosyasi().run({dosyaId: 123, kisiKurumId: 123});
  }

  async execDosyaBorcluMernis() {
    this.response = await this.$uyap.DosyaBorcluMernis().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123});
  }

  async execAvukatYetkiliKurumlar() {
    this.response = await this.$uyap.AvukatYetkiliKurumlar().run({});
  }

  async execBankaHacziParams() {
    this.response = await this.$uyap.BankaHacziParams().run({});
  }

  async execAvukatKisiselBilgileriSorgulama() {
    this.response = await this.$uyap.AvukatKisiselBilgileriSorgulama().run({})
  }

  async execAvukatIcraTalepEvrakiGonder() {
    this.response = await this.$uyap.AvukatIcraTalepEvrakiGonder().run({formData: true, data: new FormData(), })
  }

  // async execAvukatDosyaSorgulaGenel() {
  //   this.response = await this.$uyap.AvukatDosyaSorgulaGenel().run({
  //     yargiTuru: 123,
  //     yargiBirimi: 123,
  //     dosyaYil: null,
  //     dosyaSira: null,
  //     baslangicTarihi: 'asd',
  //     bitisTarihi: 'asd',
  //     dosyaKapanisBaslangisTarihi: 'asd',
  //     dosyaKapanisBitisTarihi: 'asd',
  //     dosyaKapaliMi: false,
  //     mahkeme: 'asd',
  //     pageCount: 123,
  //     pageSize: 123
  //   })
  // }

  async execAvukatSorgulama() {
    this.response = await this.$uyap.AvukatSorgulama().run({
      baroNo: '123',
      ilKodu: '35',
      tbbNo: '123',
      baroKodu: "",
      tcKimlikNo: '11111111110'
    });
  }

  async execAvukatTalepList() {
    this.response = await this.$uyap.AvukatTalepList().run({dosyaId: 123, islemTuru: 'haciz'});
  }

  async execAdliyeler() {
    this.response = await this.$uyap.Adliyeler().run({ilKodu: 34})
  }

  async execAracHacziParams() {
    this.response = await this.$uyap.AracHacziParams().run({})
  }

  async execDosyaBorcluEgm() {
    this.response = await this.$uyap.DosyaBorcluEgm().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123,pageIndex: 0})
  }

  async execDosyaBorcluEgmMahrumiyet() {
    this.response = await this.$uyap.DosyaBorcluEgmMahrumiyet().run({dosyaId: 123, kisiKurumId: 123, plaka: '35'})
  }

  async execDosyaBorcluIsyeriSgk() {
    this.response = await this.$uyap.DosyaBorcluIsyeriSgk().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123})
  }

  async execDosyaBorclulari() {
    this.response = await this.$uyap.DosyaBorclulari().run({dosyaId: 123})
  }

  async execDosyaBorcluSSK() {
    this.response = await this.$uyap.DosyaBorcluSSK().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123})
  }

  async execDosyaDetayBilgileri() {
    this.response = await this.$uyap.DosyaDetayBilgileri().run({dosyaId: 123})
  }

  async execDosyaEvraklar() {
    this.response = await this.$uyap.DosyaEvraklar().run({dosyaId: 123})
  }

  async execDosyaHarcMasrafHesabi() {
    this.response = await this.$uyap.DosyaHarcMasrafHesabi().run({tcKimlikNo: 11111111110,dosyaId:'',dosyaTurKod:35})
  }

  async execDosyaHesapBilgileri() {
    this.response = await this.$uyap.DosyaHesapBilgileri().run({dosyaId: 123})
  }

  async execDosyaKapatmaNedenleri() {
    this.response = await this.$uyap.DosyaKapatmaNedenleri().run({dosyaTurKod: 1})
  }

  async execDosyaOdemeIslemleri() {
    this.response = await this.$uyap.DosyaOdemeIslemleri().run({
      dosyaId: 123,
      harcMasrafTipi: 'asd',
      harcMasrafList: 'asd',
      postaMasraflariList: [],
      odemeTipi: 123,
      uyapId: 'asd',
      tarafDVO: '',
      vakifbankHesapBilgileri: 'asd'
    })
  }

  async execDosyaSafahat() {
    this.response = await this.$uyap.DosyaSafahat().run({dosyaId: 123, token: 123})
  }

  async execDosyaTarafBilgileri() {
    this.response = await this.$uyap.DosyaTarafBilgileri().run({dosyaId: 123})
  }

  async execGetDosyaTarafBilgileri() {
    this.response = await this.$uyap.GetDosyaTarafBilgileri().run({dosyaId: 123})
  }

  async execGetDosyaTarafListesiWithTarafRol() {
    this.response = await this.$uyap.GetDosyaTarafListesiWithTarafRol().run({dosyaId: 123, islemTuru: 1})
  }

  async execGetEvrakBlob() {
    this.response = await this.$uyap.EvrakIndir().run({evrakId: 123, dosyaId: 123, yargiTuru: 1})
  }

  async execGetIbanDetails() {
    this.response = await this.$uyap.GetIbanDetails().run({iban: 1111111111111111110, isSansurlenecek: false})
  }

  async execGetKurumMersisAdresi() {
    this.response = await this.$uyap.GetKurumMersisAdresi().run({mersisNo: '123', vergiNo: '123'})
  }

  async execGetMaasHacziParams() {
    this.response = await this.$uyap.GetMaasHacziParams().run({})
  }

  async execGetPortalAvukatTalepAdresTuruList() {
    this.response = await this.$uyap.GetPortalAvukatTalepAdresTuruList().run({})
  }

  async execGonderilebilecekEvrakListesi() {
    this.response = await this.$uyap.GonderilebilecekEvrakListesi().run({dosyaId: 123})
  }

  async execIcraPesinHarcGetir() {
    this.response = await this.$uyap.IcraPesinHarcGetir().run({dosyaId: 123})
  }

  async execIcraTakipIlamDosyasiUygunMu() {
    this.response = await this.$uyap.IcraTakipIlamDosyasiUygunMu().run({
      ilamTuru: 123,
      birimId: 123,
      dosyaSiraNo: 123,
      dosyaTurKod: 123,
      dosyaYil: '2022',
      dosyaNo: '',
      TarafList: 'asd'
    })
  }

  async execIcraTakipIlamDosyaTuru() {
    this.response = await this.$uyap.IcraTakipIlamDosyaTuru().run({
      ilamTuru: 2
    })
  }

  async execIldekiIdariBirimler() {
    this.response = await this.$uyap.IldekiIdariBirimler().run({
      il: 35,
      bltr2: 'asdasd',
      isAll: true,
    })
  }

  async execIldekiAdliyeler() {
    this.response = await this.$uyap.IldekiAdliyeler().run({
      il: 35
    })
  }

  async execIcraTalepEvrakHazirla() {
    this.response = await this.$uyap.IcraTalepEvrakHazirla().run({
        talepBilgileri: '',
        dosyaEsasNo: '123',
        filename: '',
        dosyaId: 123,
        kisiKurumId: 123
    })
  }

  async execKisiMernisAdresiVarmi() {
    this.response = await this.$uyap.KisiMernisAdresiVarmi().run({tcKimlikNo: 11111111110})
  }

  async execKisiSorgula() {
    this.response = await this.$uyap.KisiSorgula().run({tcKimlikNo: '11111111110'})
  }

  async execKurumSorgulama() {
    this.response = await this.$uyap.KurumSorgulama().run({
      kurumAdi: 'asd',
      detsisNo: '123',
      mersisNo: '123',
      vergiNo: '123'
    })
  }

  async execMahkemeBirimleri() {
    this.response = await this.$uyap.MahkemeBirimleri().run({yargiTuru: 123, yargiBirimi: 123, dosyaKapaliMi: 'asd'})
  }

  async execOdemeYap() {
    this.response = await this.$uyap.OdemeYap().run({
      odemeTipi: 123,
      harcMasrafList: '',
      harcMasrafTipi: '',
      dosyaId: 123,
      kisiKurumId: 123,
      postaMasraflariList:'',
      vakifbankHesapBilgileri: 123
    })
  }

  async execParaBirimleri() {
    this.response = await this.$uyap.ParaBirimleri().run({})
  }

  async execPortalAvukatTalepMalTuruList() {
    this.response = await this.$uyap.PortalAvukatTalepMalTuruList().run({})
  }

  async execPortalAvukatTalepTebligatTuruList() {
    this.response = await this.$uyap.PortalAvukatTalepTebligatTuruList().run({})
  }

  async execSgkKamu() {
    this.response = await this.$uyap.SgkKamu().run({dosyaId: 123, kisiKurumId: 123, sorguBakiye: 123})
  }

  async execTahsilatReddiyat() {
    this.response = await this.$uyap.TahsilatReddiyat().run({dosyaId: 123, dosyaTurKod: 1})
  }

  async execTahsilHarcOranlariniGetir() {
    this.response = await this.$uyap.TahsilHarcOranlariniGetir().run({})
  }

  async execTakibiKesinlesenBorcluListesi() {
    this.response = await this.$uyap.TakibiKesinlesenBorcluListesi().run({dosyaId: 123})
  }

  async execTamamlanmayanDosyalar() {
    this.response = await this.$uyap.TamamlanmayanDosyalar().run({dosyaTurKod: 1})
  }
}
